module.exports = __webpack_public_path__ + "static/media/cloud-gateway.d5e5bf9e.png";